import React, { FC, memo } from "react";
import { IconOffset, IconDefinitionProps } from "@toolkit/Framework/Types/Icon";
import parseIconDefinitionProps from "@toolkit/Framework/Common/Utilities/parseIconDefinitionProps";

const PinFull: FC<IconDefinitionProps> = props => {
    const { size, color, text, textColor } = parseIconDefinitionProps(props);

    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size}>
            <path
                d="M 12 2 A 8 8 0 0 1 20 9.92 c 0 5.48 -7 11.58 -7.35 11.84 a 1 1 0 0 1 -1.3 0 l -0.022 -0.019 C 10.805 21.286 4 15.304 4 9.92 A 8 8 0 0 1 12 2 z z z"
                fill={color}
                fillRule="evenodd"
            />
            {text ? (
                <text
                    fill={textColor}
                    x="50%"
                    y="47%"
                    dominantBaseline="middle"
                    textAnchor="middle"
                    style={{
                        fontFamily: "Arial, Helvetica, sans-serif",
                        fontSize: "60%",
                        fontWeight: "bold",
                    }}
                >
                    {text}
                </text>
            ) : null}
        </svg>
    );
};

export const PinFullOffset: IconOffset = {
    vertical: 8,
    horizontal: 17,
};

export default memo(PinFull);
